import React, { useState } from 'react';
import useEmailNotifications from '../../hooks/useEmailNotifications';
import CAdminDocumentEmailNotificationTable from './CAdminDocumentEmailNotificationTable';
import IEmailNotification from '../../interfaces/IEmailNotification';
import CAdminEmailNotificationFilters from '../email-notifications/CAdminEmailNotificationFilters';

const FAdminDocumentEmailNotifications = () => {
	const { data: emailNotifications } = useEmailNotifications();

	const [emailNotificationsFiltered, setEmailNotificationsFiltered] = useState<IEmailNotification[]>([]);

	return (
		<>
			<CAdminEmailNotificationFilters
				hideFilters={['contactKeywords']}
				emailNotifications={emailNotifications ?? []}
				onChange={(values) => setEmailNotificationsFiltered(values)}
			/>
			<CAdminDocumentEmailNotificationTable emailNotifications={emailNotificationsFiltered} />
		</>
	);
};

export default FAdminDocumentEmailNotifications;
